// src/services/firebase.js
import { initializeApp, getApps } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getVertexAI, getGenerativeModel } from "firebase/vertexai-preview";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

let app, db, storage, auth, vertexAI, model;

// 한 군데에서만 모델 이름 관리
const GEMINI_MODEL_NAME = "gemini-2.5-flash-lite"; // 텍스트 챗용 경량 모델

export function ensureFirebase() {
    // 앱 초기화
    if (!getApps().length) {
        app = initializeApp(firebaseConfig);
    } else {
        app = app || getApps()[0];
    }

    // 기본 Firebase 서비스
    db = db || getFirestore();
    storage = storage || getStorage();
    auth = auth || getAuth();

    // Firebase AI Logic (Vertex AI) 초기화
    if (!vertexAI) {
        vertexAI = getVertexAI(app);
    }
    if (!model) {
        model = getGenerativeModel(vertexAI, { model: GEMINI_MODEL_NAME });
    }

    return { app, db, storage, auth, vertexAI, model };
}

// 앱 로드 시 한 번 강제 초기화
ensureFirebase();

// 공용 헬퍼들
export function getDb() {
    return db || ensureFirebase().db;
}

export function getAuthSafe() {
    return auth || ensureFirebase().auth;
}

export function getVertexAISafe() {
    const { vertexAI: v, model: m } = ensureFirebase();
    return { vertexAI: v, model: m };
}

// 기본 export
export { db, storage, auth, app as firebaseApp, vertexAI, model };
